/* import __COLOCATED_TEMPLATE__ from './carousel-editor.hbs'; */
/* RESPONSIBLE TEAM: team-messenger */
import Component from '@glimmer/component';
import { preferredDevices } from 'embercom/models/data/outbound/constants';

export default class CarouselEditor extends Component {
  preferredDevicesToHide = [preferredDevices.web];
}
